import { ConnectGuide } from '../../components/guide/ConnectGuide';
import styles from './GuidePage.module.css';

/** Раздел «Инструкции»: только инструкция, без ключей — ключи и кнопка «Подключить» на главной */
export function GuidePage() {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerIcon} aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
          </svg>
        </div>
        <div>
          <h1 className={styles.title}>Инструкция</h1>
          <p className={styles.subtitle}>Как подключиться: приложение, ключ, кнопка «Подключить»</p>
        </div>
      </header>

      <ConnectGuide subscriptionUrl="" />
    </div>
  );
}
